import React from 'react';
import PropTypes from 'prop-types';

import { Dialog, FlatButton, SelectField, MenuItem, TextField } from 'material-ui';

const { bool, func, string } = PropTypes;

const CancelReason = ({ cancellationReason, cancellationError, isOpen, submitDisabled, onAdditionalDetailsChange, onCancelReasonChange, onCloseClick, onSubmitClick }) => {
  const actions = [
    <FlatButton
      label="Nevermind, Go Back."
      primary
      onClick={onCloseClick}
    />,
    <FlatButton
      label="Cancel My Subscription"
      onClick={onSubmitClick}
      disabled={cancellationReason === null || submitDisabled}
    />,
  ];

  const cancellationReasons = [
    "Just temporary. We'll be back.",
    'Technical issues',
    "Didn't get what we expected.",
    'It is too expensive.',
    'Other',
  ];

  return (
    <Dialog
      actions={actions}
      title="Is This Really Goodbye?"
      open={isOpen}
      modal
      onRequestClose={onCloseClick}
    >
      <p>We'd love the opportunity to resolve any issue. Please reach out to <a href="mailto:support@tourconnect.com">support@tourconnect.com</a> before cancelling your account.</p>
      <p>If you would still like to proceed with cancelling your account, please let us know why and we'd appreciated any additional details which could help us get better. Thank you.</p>
      <SelectField
        autoWidth
        floatingLabelText="Cancellation Reason"
        onChange={onCancelReasonChange}
        value={cancellationReason}
      >
        {cancellationReasons.map((reason, i) => <MenuItem key={i} value={reason} primaryText={reason} />)}
      </SelectField>
      <TextField
        fullWidth
        floatingLabelText="Please help us get better by providing us with a little more detail."
        multiLine
        onChange={onAdditionalDetailsChange}
        rows={4}
        rowsMax={6}
      />
    { cancellationError && <p style={{ color: 'red' }}>{cancellationError}</p>}
    </Dialog>
  );
};

CancelReason.propTypes = {
  cancellationReason: string,
  cancellationError: string,
  isOpen: bool,
  submitDisabled: bool,
  onAdditionalDetailsChange: func,
  onCancelReasonChange: func,
  onCloseClick: func,
  onSubmitClick: func,
};

export default CancelReason;



// WEBPACK FOOTER //
// ./src/app/components/settings/billing/cancel-reason.jsx